import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-8 font-inter">
      <div className="text-center max-w-md w-full">
        <div className="w-24 h-24 bg-indigo-50 rounded-2xl flex items-center justify-center mx-auto mb-8">
          <span className="material-symbols-outlined text-5xl text-[#4f46e5]">search_off</span>
        </div>
        <p className="text-sm font-bold tracking-widest text-[#4f46e5] uppercase mb-3">Erro 404</p>
        <h1 className="text-6xl font-bold font-manrope text-slate-900 mb-4 tracking-tight">Página não encontrada</h1>
        <p className="text-slate-500 font-medium mb-10 leading-relaxed">
          A página que você está procurando não existe, foi removida ou o endereço está incorreto.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-white border border-slate-200 text-slate-700 font-bold rounded-xl hover:bg-slate-50 transition-colors shadow-sm"
          >
            Voltar
          </button>
          <button
            onClick={() => navigate(token ? '/app/dashboard' : '/')}
            className="px-6 py-3 bg-[#4f46e5] text-white font-bold rounded-xl hover:bg-[#4338ca] transition-colors shadow-md shadow-indigo-500/20"
          >
            {token ? 'Ir para o Painel' : 'Ir para o Início'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
